// extracted by mini-css-extract-plugin
export default {"Stats":"Stats_Stats__5VhO+","Format":"Stats_Format__1u+r4","Trigger":"Stats_Trigger__TLaKN"};